// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/p2p/stylesheet/index.scss
 ** module id = 457
 ** module chunks = 1
 **/